import React from 'react'
import Image from '../../../images/sellerpolicies/9.png'

const Misleading_information = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Misleading Information</h2>
            <p>All Sellers are required to provide complete and accurate information when uploading products. This includes but may not be limited to:</p>
            <ul>
                <li>•	Accurate information on product color, fabric, sizing, and variation</li> 
                <li>•	Correct details of what’s in the box and what will be packing type.</li>
                <li>•	Accurate product weight information just for the KAAY use</li>
            </ul>
            <p>You may select "No Brand" if the product is local and has no specific brand. If the product is branded, you must add the brand.</p>
        </div>
      </div>
    </div>
  )
}

export default Misleading_information
